module.exports = __webpack_public_path__ + "static/media/pending-status-icon.1ab9bf89.svg";